import React, { useCallback } from 'react';
import styles from './CallToActionListItem.module.scss';
import TimeInput from '../../../../components/TimeInput/TimeInput';
import cx from 'classnames';

const CallToActionListItem = ({ item, onClick }) => {
  const handleClickCta = useCallback(() => {
    onClick(item);
  }, [item]);

  return (
    <li className={styles.itemContainer} onClick={handleClickCta}>
      <div className={styles.timestampsContainer}>
        <TimeInput
          variant="basic"
          disabled={true}
          inputClassName={styles.inputClassName}
          showControls={false}
          value={item.offset / 1000}
        />
        {'-'}
        <TimeInput
          variant="basic"
          disabled={true}
          inputClassName={cx(styles.inputClassName, styles.endTimestamp)}
          showControls={false}
          value={(item.offset + item.duration) / 1000}
        />
      </div>
      <span className={styles.ctaLabel}>{item.text}</span>
      {item.url && <span className={cx(styles.ctaLabel, styles.url)}>{item?.url}</span>}
    </li>
  );
};

export default CallToActionListItem;
